import { View, Text, StyleSheet, TouchableOpacity } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { useTheme } from '../../../contexts/ThemeContext';
import { useLanguage } from '../../../contexts/LanguageContext';
import { FONTS } from '../../../constants/config';
import { createShadow } from '../../../utils/styles';

interface DetailHeaderProps {
  title: string;
  weight: number;
  description?: string;
  entityName?: string;
  onEditSchedule?: () => void;
}

export default function DetailHeader({ title, weight, description, entityName, onEditSchedule }: DetailHeaderProps) {
  const { colors } = useTheme();
  const { language } = useLanguage();
  const isRTL = language === 'ar';

  return (
    <View
      style={[
        styles.container,
        {
          backgroundColor: colors.card,
          borderColor: colors.cardBorder,
        },
        createShadow(0, 1, 3, '#000', 0.1),
      ]}
    >
      <View style={{ flexDirection: 'row', alignItems: 'center' }}>
        {onEditSchedule && (
          <TouchableOpacity onPress={onEditSchedule} style={{ padding: 4 }}>
            <Ionicons name="create-outline" size={20} color={colors.textSecondary} />
          </TouchableOpacity>
        )}
        <Text style={[styles.title, { color: colors.textPrimary, textAlign: isRTL ? 'right' : 'left', flex: 1 }]}>
          {title}
        </Text>
      </View>
      {description ? (
        <Text style={[styles.description, { color: '#64748B', textAlign: isRTL ? 'right' : 'left' }]}>
          {description}
        </Text>
      ) : null}
      {entityName ? (
        <View style={[styles.tagRow, { justifyContent: isRTL ? 'flex-end' : 'flex-start' }]}>
          <View style={styles.entityTag}>
            <Text style={styles.entityTagText}>{entityName}</Text>
          </View>
        </View>
      ) : null}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    borderRadius: 8,
    borderWidth: 1,
    paddingHorizontal: 20,
    paddingVertical: 14,
    gap: 8,
  },
  title: {
    fontSize: 18,
    fontFamily: FONTS.medium,
  },
  description: {
    fontSize: 14,
    fontFamily: FONTS.regular,
    lineHeight: 22,
  },
  tagRow: {
    flexDirection: 'row',
    marginTop: 4,
  },
  entityTag: {
    backgroundColor: '#A6813F',
    borderRadius: 40,
    paddingHorizontal: 8,
    paddingVertical: 4,
  },
  entityTagText: {
    fontSize: 12,
    fontFamily: FONTS.regular,
    color: '#FFFFFF',
  },
});
